// The registry of the icons of the staff app (Hugeicons Pro, Rounded, Stroke). One line for each file of `assets/icons/hugeicons/stroke`:
// `icon.test.tsx` fails when the folder and this list differ, so an icon file is either in this list or not in the repository. Add an
// icon here and its name becomes a valid `IconName`. The files are copied from the licensed library at the repository root
// (`hugeicons/`, git-ignored); the whole library is never committed.

import iAddCircle from "../assets/icons/hugeicons/stroke/add-circle.svg?raw";
import iAirplane02 from "../assets/icons/hugeicons/stroke/airplane-02.svg?raw";
import iAlert02 from "../assets/icons/hugeicons/stroke/alert-02.svg?raw";
import iAlertDiamond from "../assets/icons/hugeicons/stroke/alert-diamond.svg?raw";
import iAnalyticsUp from "../assets/icons/hugeicons/stroke/analytics-up.svg?raw";
import iApple from "../assets/icons/hugeicons/stroke/apple.svg?raw";
import iArchive01 from "../assets/icons/hugeicons/stroke/archive-01.svg?raw";
import iArrowDown01Round from "../assets/icons/hugeicons/stroke/arrow-down-01-round.svg?raw";
import iArrowExpand01Round from "../assets/icons/hugeicons/stroke/arrow-expand-01-round.svg?raw";
import iArrowLeft01Round from "../assets/icons/hugeicons/stroke/arrow-left-01-round.svg?raw";
import iArrowLeft02Round from "../assets/icons/hugeicons/stroke/arrow-left-02-round.svg?raw";
import iArrowRight01Round from "../assets/icons/hugeicons/stroke/arrow-right-01-round.svg?raw";
import iArrowRight02Round from "../assets/icons/hugeicons/stroke/arrow-right-02-round.svg?raw";
import iArrowTurnBackwardRound from "../assets/icons/hugeicons/stroke/arrow-turn-backward-round.svg?raw";
import iArrowUp01Round from "../assets/icons/hugeicons/stroke/arrow-up-01-round.svg?raw";
import iArrowUpDoubleRound from "../assets/icons/hugeicons/stroke/arrow-up-double-round.svg?raw";
import iAttachment01 from "../assets/icons/hugeicons/stroke/attachment-01.svg?raw";
import iBookOpen01 from "../assets/icons/hugeicons/stroke/book-open-01.svg?raw";
import iBubbleChat from "../assets/icons/hugeicons/stroke/bubble-chat.svg?raw";
import iCalendar03 from "../assets/icons/hugeicons/stroke/calendar-03.svg?raw";
import iCalendarBlock01 from "../assets/icons/hugeicons/stroke/calendar-block-01.svg?raw";
import iCancel01 from "../assets/icons/hugeicons/stroke/cancel-01.svg?raw";
import iCancelCircle from "../assets/icons/hugeicons/stroke/cancel-circle.svg?raw";
import iCheckmarkBadge01 from "../assets/icons/hugeicons/stroke/checkmark-badge-01.svg?raw";
import iCheckmarkCircle02 from "../assets/icons/hugeicons/stroke/checkmark-circle-02.svg?raw";
import iCheckmarkSquare02 from "../assets/icons/hugeicons/stroke/checkmark-square-02.svg?raw";
import iCircle from "../assets/icons/hugeicons/stroke/circle.svg?raw";
import iClock01 from "../assets/icons/hugeicons/stroke/clock-01.svg?raw";
import iCloudAngledRain from "../assets/icons/hugeicons/stroke/cloud-angled-rain.svg?raw";
import iComputer from "../assets/icons/hugeicons/stroke/computer.svg?raw";
import iCreditCard from "../assets/icons/hugeicons/stroke/credit-card.svg?raw";
import iCrown from "../assets/icons/hugeicons/stroke/crown.svg?raw";
import iCursor01 from "../assets/icons/hugeicons/stroke/cursor-01.svg?raw";
import iDashboardSpeed01 from "../assets/icons/hugeicons/stroke/dashboard-speed-01.svg?raw";
import iDownload01 from "../assets/icons/hugeicons/stroke/download-01.svg?raw";
import iEdit02 from "../assets/icons/hugeicons/stroke/edit-02.svg?raw";
import iFileEdit from "../assets/icons/hugeicons/stroke/file-edit.svg?raw";
import iFileImport from "../assets/icons/hugeicons/stroke/file-import.svg?raw";
import iFilterHorizontal from "../assets/icons/hugeicons/stroke/filter-horizontal.svg?raw";
import iFlag01 from "../assets/icons/hugeicons/stroke/flag-01.svg?raw";
import iGem from "../assets/icons/hugeicons/stroke/gem.svg?raw";
import iHelpCircle from "../assets/icons/hugeicons/stroke/help-circle.svg?raw";
import iHome01 from "../assets/icons/hugeicons/stroke/home-01.svg?raw";
import iHourglass from "../assets/icons/hugeicons/stroke/hourglass.svg?raw";
import iHourglassOff from "../assets/icons/hugeicons/stroke/hourglass-off.svg?raw";
import iInbox from "../assets/icons/hugeicons/stroke/inbox.svg?raw";
import iInformationCircle from "../assets/icons/hugeicons/stroke/information-circle.svg?raw";
import iKeyboard from "../assets/icons/hugeicons/stroke/keyboard.svg?raw";
import iLayers01 from "../assets/icons/hugeicons/stroke/layers-01.svg?raw";
import iLayout3Column from "../assets/icons/hugeicons/stroke/layout-3-column.svg?raw";
import iLink01 from "../assets/icons/hugeicons/stroke/link-01.svg?raw";
import iLocation01 from "../assets/icons/hugeicons/stroke/location-01.svg?raw";
import iLogout01 from "../assets/icons/hugeicons/stroke/logout-01.svg?raw";
import iMail01 from "../assets/icons/hugeicons/stroke/mail-01.svg?raw";
import iMapPin from "../assets/icons/hugeicons/stroke/map-pin.svg?raw";
import iMenu01 from "../assets/icons/hugeicons/stroke/menu-01.svg?raw";
import iMenu02 from "../assets/icons/hugeicons/stroke/menu-02.svg?raw";
import iMinusSign from "../assets/icons/hugeicons/stroke/minus-sign.svg?raw";
import iMinusSignCircle from "../assets/icons/hugeicons/stroke/minus-sign-circle.svg?raw";
import iMoon from "../assets/icons/hugeicons/stroke/moon.svg?raw";
import iNote01 from "../assets/icons/hugeicons/stroke/note-01.svg?raw";
import iNotification01 from "../assets/icons/hugeicons/stroke/notification-01.svg?raw";
import iPause from "../assets/icons/hugeicons/stroke/pause.svg?raw";
import iPlay from "../assets/icons/hugeicons/stroke/play.svg?raw";
import iPlayCircle from "../assets/icons/hugeicons/stroke/play-circle.svg?raw";
import iPlusSign from "../assets/icons/hugeicons/stroke/plus-sign.svg?raw";
import iRefresh from "../assets/icons/hugeicons/stroke/refresh.svg?raw";
import iRepeat from "../assets/icons/hugeicons/stroke/repeat.svg?raw";
import iRotateLeft01 from "../assets/icons/hugeicons/stroke/rotate-left-01.svg?raw";
import iRoute01 from "../assets/icons/hugeicons/stroke/route-01.svg?raw";
import iSearch from "../assets/icons/hugeicons/stroke/search.svg?raw";
import iSecurityCheck from "../assets/icons/hugeicons/stroke/security-check.svg?raw";
import iSent from "../assets/icons/hugeicons/stroke/sent.svg?raw";
import iSidebarLeft from "../assets/icons/hugeicons/stroke/sidebar-left.svg?raw";
import iSmartPhone01 from "../assets/icons/hugeicons/stroke/smart-phone-01.svg?raw";
import iSparkles from "../assets/icons/hugeicons/stroke/sparkles.svg?raw";
import iSquareLock02 from "../assets/icons/hugeicons/stroke/square-lock-02.svg?raw";
import iStar from "../assets/icons/hugeicons/stroke/star.svg?raw";
import iSun01 from "../assets/icons/hugeicons/stroke/sun-01.svg?raw";
import iTabletPen from "../assets/icons/hugeicons/stroke/tablet-pen.svg?raw";
import iTarget02 from "../assets/icons/hugeicons/stroke/target-02.svg?raw";
import iTask01 from "../assets/icons/hugeicons/stroke/task-01.svg?raw";
import iTestTube01 from "../assets/icons/hugeicons/stroke/test-tube-01.svg?raw";
import iThumbsUp from "../assets/icons/hugeicons/stroke/thumbs-up.svg?raw";
import iTick02 from "../assets/icons/hugeicons/stroke/tick-02.svg?raw";
import iTimeQuarter from "../assets/icons/hugeicons/stroke/time-quarter.svg?raw";
import iTimer01 from "../assets/icons/hugeicons/stroke/timer-01.svg?raw";
import iUnavailable from "../assets/icons/hugeicons/stroke/unavailable.svg?raw";
import iUnfoldMoreRound from "../assets/icons/hugeicons/stroke/unfold-more-round.svg?raw";
import iUser from "../assets/icons/hugeicons/stroke/user.svg?raw";
import iUserAccount from "../assets/icons/hugeicons/stroke/user-account.svg?raw";
import iUserAdd02 from "../assets/icons/hugeicons/stroke/user-add-02.svg?raw";
import iUserBlock01 from "../assets/icons/hugeicons/stroke/user-block-01.svg?raw";
import iUserCheck01 from "../assets/icons/hugeicons/stroke/user-check-01.svg?raw";
import iUserEdit01 from "../assets/icons/hugeicons/stroke/user-edit-01.svg?raw";
import iUserGroup from "../assets/icons/hugeicons/stroke/user-group.svg?raw";
import iUserRemove01 from "../assets/icons/hugeicons/stroke/user-remove-01.svg?raw";
import iUserSettings01 from "../assets/icons/hugeicons/stroke/user-settings-01.svg?raw";
import iUserSwitch from "../assets/icons/hugeicons/stroke/user-switch.svg?raw";
import iView from "../assets/icons/hugeicons/stroke/view.svg?raw";
import iViewOff from "../assets/icons/hugeicons/stroke/view-off.svg?raw";
import iWifiDisconnected01 from "../assets/icons/hugeicons/stroke/wifi-disconnected-01.svg?raw";
import iZoomInArea from "../assets/icons/hugeicons/stroke/zoom-in-area.svg?raw";

export const iconSources = {
  "add-circle": iAddCircle,
  "airplane-02": iAirplane02,
  "alert-02": iAlert02,
  "alert-diamond": iAlertDiamond,
  "analytics-up": iAnalyticsUp,
  apple: iApple,
  "archive-01": iArchive01,
  "arrow-down-01-round": iArrowDown01Round,
  "arrow-expand-01-round": iArrowExpand01Round,
  "arrow-left-01-round": iArrowLeft01Round,
  "arrow-left-02-round": iArrowLeft02Round,
  "arrow-right-01-round": iArrowRight01Round,
  "arrow-right-02-round": iArrowRight02Round,
  "arrow-turn-backward-round": iArrowTurnBackwardRound,
  "arrow-up-01-round": iArrowUp01Round,
  "arrow-up-double-round": iArrowUpDoubleRound,
  "attachment-01": iAttachment01,
  "book-open-01": iBookOpen01,
  "bubble-chat": iBubbleChat,
  "calendar-03": iCalendar03,
  "calendar-block-01": iCalendarBlock01,
  "cancel-01": iCancel01,
  "cancel-circle": iCancelCircle,
  "checkmark-badge-01": iCheckmarkBadge01,
  "checkmark-circle-02": iCheckmarkCircle02,
  "checkmark-square-02": iCheckmarkSquare02,
  circle: iCircle,
  "clock-01": iClock01,
  "cloud-angled-rain": iCloudAngledRain,
  computer: iComputer,
  "credit-card": iCreditCard,
  crown: iCrown,
  "cursor-01": iCursor01,
  "dashboard-speed-01": iDashboardSpeed01,
  "download-01": iDownload01,
  "edit-02": iEdit02,
  "file-edit": iFileEdit,
  "file-import": iFileImport,
  "filter-horizontal": iFilterHorizontal,
  "flag-01": iFlag01,
  gem: iGem,
  "help-circle": iHelpCircle,
  "home-01": iHome01,
  hourglass: iHourglass,
  "hourglass-off": iHourglassOff,
  inbox: iInbox,
  "information-circle": iInformationCircle,
  keyboard: iKeyboard,
  "layers-01": iLayers01,
  "layout-3-column": iLayout3Column,
  "link-01": iLink01,
  "location-01": iLocation01,
  "logout-01": iLogout01,
  "mail-01": iMail01,
  "map-pin": iMapPin,
  "menu-01": iMenu01,
  "menu-02": iMenu02,
  "minus-sign": iMinusSign,
  "minus-sign-circle": iMinusSignCircle,
  moon: iMoon,
  "note-01": iNote01,
  "notification-01": iNotification01,
  pause: iPause,
  play: iPlay,
  "play-circle": iPlayCircle,
  "plus-sign": iPlusSign,
  refresh: iRefresh,
  repeat: iRepeat,
  "rotate-left-01": iRotateLeft01,
  "route-01": iRoute01,
  search: iSearch,
  "security-check": iSecurityCheck,
  sent: iSent,
  "sidebar-left": iSidebarLeft,
  "smart-phone-01": iSmartPhone01,
  sparkles: iSparkles,
  "square-lock-02": iSquareLock02,
  star: iStar,
  "sun-01": iSun01,
  "tablet-pen": iTabletPen,
  "target-02": iTarget02,
  "task-01": iTask01,
  "test-tube-01": iTestTube01,
  "thumbs-up": iThumbsUp,
  "tick-02": iTick02,
  "time-quarter": iTimeQuarter,
  "timer-01": iTimer01,
  unavailable: iUnavailable,
  "unfold-more-round": iUnfoldMoreRound,
  user: iUser,
  "user-account": iUserAccount,
  "user-add-02": iUserAdd02,
  "user-block-01": iUserBlock01,
  "user-check-01": iUserCheck01,
  "user-edit-01": iUserEdit01,
  "user-group": iUserGroup,
  "user-remove-01": iUserRemove01,
  "user-settings-01": iUserSettings01,
  "user-switch": iUserSwitch,
  view: iView,
  "view-off": iViewOff,
  "wifi-disconnected-01": iWifiDisconnected01,
  "zoom-in-area": iZoomInArea,
} as const;

export type IconName = keyof typeof iconSources;
